/**
 * Created by patricio on 2016-10-28.
 */

/*
payment/view-payment-method-link

Will display selected payment method on deposit page.
It takes the user to the payment methods page when clicked.

<ul class="link-list">
    <li class="link-list__item">
        <a href="#" class="link-list__item-link">
            <span class="link-list__item-text">Payment Method</span>
            <span class="link-list__item-text link-list__item-text-selected">Credit Card</span>
            <span class="link-list__item-text ink-list__item-text-card-number">1234</span>
            <svg viewBox="0 0 64 64" class="link-list__continue-icon" aria-hidden="true">
                <path d="M21.76,51.75a1.08,1.08,0,0,1,0-1.5L40,32,21.88,13.74a1.06,1.06,0,0,1,1.5-1.5
                l18.79,19a0.73,0.73,0,0,1,.27.33,1.17,1.17,0,0,1,0,.9,0.73,0.73,0,0,1-.27.33l-18.85,19A0.
                94,0.94,0,0,1,23,52a1.33,1.33,0,0,1-.42.06A1.42,1.42,0,0,1,22.15,52,0.9,0.9,0,0,1,21.76,51.75Z" />
            </svg>
        </a>
    </li>
</ul>

*/

import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import viewTextKeys from '../../commonview/lib/view-textkeys.js';

const classnameOpen = 'u-show';
const classnameClose = 'u-hide';
const create = core.create;
let selectedPaymentMethodText;
let textKeysObj;

function createListElement() {
	return create({
		type: 'li',
		class: 'link-list__item link-list__item--single u-b-radius u-m0'
	});
}

function createLinkElement() {
	return create({
		type: 'a',
		class: 'link-list__item-link',
		href: '#'
	});
}

function createTextWrapperForLink() {
	// this is a div that just wraps the texts inside the link (as block element)
	return create({
		type: 'div'
	});
}

function createLinkStaticTextElement(txt) {
	// This display static text "Payment Method".
	const elm = create({
		type: 'span',
		class: 'payment-method-title u-dib'
	});
	/* txt is essential input and if it is empty throw error */
	elm.innerHTML = txt;
	return elm;
}

function createLinkSelectedMethodTextElement(txt) {
	// added this span to update only the text, otherwise the icon is replaced as well.
	const elm = create({
		type: 'span',
		class: 'payment-method-sub-title u-dib'
	});
	/* txt is essential input and if it is empty throw error */
	elm.innerHTML = txt;
	return elm;
}

function createLinkCardNumberText() {
	// This will hold the last 4 digits of the selected credit card if any
	return create({
		type: 'span',
		class: 'payment-method-sub-title'
	});
}

function createSvgIcon() {
	return create({
		type: 'svg',
		viewBox: '0 0 24 24',
		class: 'link-list__continue-icon',
		'aria-hidden': true
	});
}

function createPathForIcon() {
	return create({
		type: 'path',
		d: 'M8.11 19.43C7.96 19.28 7.96 19.03 8.11 18.87L14.95 12.03 8.16 5.18C8 5.02 8 4.77 8.16 4.62 8.31 4.46 8.57 4.46 8.72 4.62L15.77 11.74C15.81 11.77 15.85 11.81 15.87 11.87 15.91 11.97 15.91 12.09 15.87 12.2 15.85 12.25 15.81 12.3 15.77 12.33L8.7 19.45C8.66 19.48 8.62 19.51 8.58 19.53 8.53 19.54 8.47 19.55 8.42 19.55 8.37 19.55 8.32 19.54 8.27 19.53 8.21 19.51 8.16 19.48 8.11 19.43L8.11 19.43Z' // eslint-disable-line max-len
	});
}

function extractLastDigits(str, no = 4) {
	return (str && str.substring(str.length - no));
}

function updateFourDigits(elm, state) {
	let cardNo = null;
	// fetch cardNo coming from last used method or from new added CC
	if (state && state.fetch_methoddetails) {
		cardNo = state.fetch_methoddetails.creditcardlast;
	} else if (state && state.submit_payment) {
		cardNo = state.submit_payment.currentcard.card.cn;
	}
	cardNo = extractLastDigits(cardNo, 4);
	if (elm && cardNo) {
		elm.innerHTML = `${cardNo}`; // eslint-disable-line no-param-reassign
	} else if (elm) {
		elm.innerHTML = ''; // eslint-disable-line no-param-reassign
	}
}

function deleteAllElements(elmObj) {
	return core.deleteElementsInObjectExcept(elmObj, [], 'view-payment-method-link');
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameClose);
		core.addClass(elm, classnameOpen);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameOpen);
	core.addClass(elm, classnameClose);
}

function clickBtnHandler(e, onClickCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		actions.viewPaymentMethodLink();
		onClickCb();
	}

	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, handler, eventFilter) {
	function handleCreator(e) {
		clickBtnHandler(e, handler, eventFilter);
	}

	core.addListener(elm, 'click', handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler) {
	if (elm) {
		core.removeListener(elm, 'click', handler);
	}
}

export default {
	create(p) {
		const classNameEventFilter = 'js-event-filter-payment-method-link';
		const callbackOnClick = p.cb;
		const elements = {};
		selectedPaymentMethodText = p.paymentMethodText;
		textKeysObj = viewTextKeys.depositflow();
		elements.wrap = createListElement();
		elements.link = elements.link || createLinkElement();
		elements.linkTextWrapper = elements.linkTextWrapper || createTextWrapperForLink();
		elements.linkStaticText = elements.linkStaticText || createLinkStaticTextElement(textKeysObj['deposit-payment-method']);
		elements.linkSelectedPaymentMethodText = elements.linkSelectedPaymentMethodText || createLinkSelectedMethodTextElement(selectedPaymentMethodText);
		elements.linkCardNumber = elements.linkCardNumber || createLinkCardNumberText();
		elements.svg = elements.svg || createSvgIcon();
		elements.path = elements.path || createPathForIcon();
		elements.svg.appendChild(elements.path);
		elements.linkTextWrapper.appendChild(elements.linkStaticText);
		elements.linkTextWrapper.appendChild(elements.linkSelectedPaymentMethodText);
		elements.linkTextWrapper.appendChild(elements.linkCardNumber);
		elements.link.appendChild(elements.linkTextWrapper);
		elements.link.appendChild(elements.svg);
		elements.wrap.appendChild(elements.link);
		const handler = addListeners(elements.wrap, callbackOnClick, classNameEventFilter);
		/* the button is displayed by default,
		 hide it actively from .hide() */
		show(elements.wrap);
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update(state) {
				if (state && state.fetch_methoddetails) {
					updateFourDigits(elements.linkCardNumber, state);
				}
				if ((state && state.submit_payment) && state.submit_payment.currentcard.card.cn) {
					updateFourDigits(elements.linkCardNumber, state);
				}
				if ((state && state.view_paymentform) && state.view_paymentform.name) {
					/* update payment method on button */
					elements.linkSelectedPaymentMethodText.innerHTML = state.view_paymentform.name;
				}
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler);
				deleteAllElements(elements);
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-payment-method-link.js